import { cmsHttp } from 'shared/api/mfe-axios';
import { buildSpringPageParams } from 'shared/api/list-query-params';
import { REQUEST, SUCCESS, FAILURE } from 'shared/lib/reducers/action-type.util';
export const ACTION_TYPES = {
    FETCH_CARD_UNFREEZE_REQUESTS_LIST: 'cardUnfreezeRequest/FETCH_CARD_UNFREEZE_REQUESTS_LIST',
    FETCH_CARD_UNFREEZE_REQUESTS_BY_CARD_ID: 'cardUnfreezeRequest/FETCH_CARD_UNFREEZE_REQUESTS_BY_CARD_ID',
    CREATE_CARD_UNFREEZE_REQUEST: 'cardUnfreezeRequest/CREATE_CARD_UNFREEZE_REQUEST',
    UPDATE_CARD_UNFREEZE_REQUEST: 'cardUnfreezeRequest/UPDATE_CARD_UNFREEZE_REQUEST',
    APPROVE_CARD_UNFREEZE_REQUEST: 'cardUnfreezeRequest/APPROVE_CARD_UNFREEZE_REQUEST',
    RESET: 'cardUnfreezeRequest/RESET',
};
const listApiUrl = 'api/card-unfreeze-requests';
const apiUrl = 'api/card-unfreeze-requests';
const initialState = {
    loading: false,
    errorMessage: null,
    entities: [],
    updating: false,
    updateSuccess: false,
    totalItems: 0,
};
export default (state = initialState, action) => {
    switch (action.type) {
        case REQUEST(ACTION_TYPES.FETCH_CARD_UNFREEZE_REQUESTS_LIST):
        case REQUEST(ACTION_TYPES.FETCH_CARD_UNFREEZE_REQUESTS_BY_CARD_ID):
            return {
                ...state,
                errorMessage: null,
                updateSuccess: false,
                loading: true,
            };
        case REQUEST(ACTION_TYPES.CREATE_CARD_UNFREEZE_REQUEST):
        case REQUEST(ACTION_TYPES.UPDATE_CARD_UNFREEZE_REQUEST):
        case REQUEST(ACTION_TYPES.APPROVE_CARD_UNFREEZE_REQUEST):
            return {
                ...state,
                errorMessage: null,
                updateSuccess: false,
                updating: true,
            };
        case FAILURE(ACTION_TYPES.FETCH_CARD_UNFREEZE_REQUESTS_LIST):
        case FAILURE(ACTION_TYPES.FETCH_CARD_UNFREEZE_REQUESTS_BY_CARD_ID):
            return {
                ...state,
                loading: false,
                updating: false,
                updateSuccess: false,
                errorMessage: action.payload,
            };
        case FAILURE(ACTION_TYPES.CREATE_CARD_UNFREEZE_REQUEST):
        case FAILURE(ACTION_TYPES.UPDATE_CARD_UNFREEZE_REQUEST):
        case FAILURE(ACTION_TYPES.APPROVE_CARD_UNFREEZE_REQUEST):
            return {
                ...state,
                loading: false,
                updating: false,
                updateSuccess: false,
                errorMessage: action.payload,
            };
        case SUCCESS(ACTION_TYPES.FETCH_CARD_UNFREEZE_REQUESTS_LIST):
        case SUCCESS(ACTION_TYPES.FETCH_CARD_UNFREEZE_REQUESTS_BY_CARD_ID): {
            const body = action.payload.data;
            const list = Array.isArray(body) ? body : body?.content ?? [];
            const countHeader = action.payload.headers?.['x-total-count'];
            const total = countHeader != null && countHeader !== '' ? parseInt(countHeader, 10) : list.length;
            return {
                ...state,
                loading: false,
                entities: list,
                totalItems: Number.isNaN(total) ? list.length : total,
            };
        }
        case SUCCESS(ACTION_TYPES.CREATE_CARD_UNFREEZE_REQUEST):
        case SUCCESS(ACTION_TYPES.UPDATE_CARD_UNFREEZE_REQUEST):
        case SUCCESS(ACTION_TYPES.APPROVE_CARD_UNFREEZE_REQUEST):
            return {
                ...state,
                updating: false,
                updateSuccess: true,
                loading: false,
            };
        case ACTION_TYPES.RESET:
            return { ...initialState };
        default:
            return state;
    }
};
export const getEntities = (params) => ({
    type: ACTION_TYPES.FETCH_CARD_UNFREEZE_REQUESTS_LIST,
    payload: cmsHttp().get(listApiUrl, params === undefined ? undefined : { params: buildSpringPageParams(params) }),
});
export const getEntitiesByCardId = (cardId, params) => ({
    type: ACTION_TYPES.FETCH_CARD_UNFREEZE_REQUESTS_BY_CARD_ID,
    payload: cmsHttp().get(`${apiUrl}/card/${cardId}`, params === undefined ? undefined : { params: buildSpringPageParams(params) }),
});
export const createEntity = (body) => async (dispatch) => dispatch({
    type: ACTION_TYPES.CREATE_CARD_UNFREEZE_REQUEST,
    payload: cmsHttp().post(apiUrl, body),
});
export const updateEntity = (body) => async (dispatch) => {
    if (body.id == null) {
        throw new Error('card unfreeze request id is required');
    }
    return dispatch({
        type: ACTION_TYPES.UPDATE_CARD_UNFREEZE_REQUEST,
        payload: cmsHttp().put(`${apiUrl}/${body.id}`, body),
    });
};
export const approveRequest = (id, approverId) => async (dispatch) => dispatch({
    type: ACTION_TYPES.APPROVE_CARD_UNFREEZE_REQUEST,
    payload: cmsHttp().post(`${apiUrl}/${id}/approve`, null, approverId == null ? undefined : { params: { approverId } }),
});
export const reset = () => ({
    type: ACTION_TYPES.RESET,
});
